import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUserUpload } from '../useUserUpload/useUserUpload';
import * as S from './UploadAlert.styles';

interface UploadAlertProps {
  onViewDetails: () => void;
}

export const UploadAlert = ({ onViewDetails }: UploadAlertProps) => {
  const { t } = useTranslation(['chat']);

  const { alertOpen, errorFiles, toggleAlertOpen } = useUserUpload(state => ({
    alertOpen: state.alertOpen,
    toggleAlertOpen: state.toggleAlertOpen,
    errorFiles: state.files.filter(f => f.status === 'error'),
  }));

  const title = (() => {
    if (errorFiles.length === 1) {
      return t('chat:uploadAlert.singleFileError', {
        errorMessage: errorFiles[0].errorMessage,
      });
    }

    return t('chat:uploadAlert.failedToUploadWithCount', {
      count: errorFiles.length,
    });
  })();

  return (
    alertOpen && (
      <S.StyledUploadAlert
        title={title}
        onClose={() => {
          toggleAlertOpen(false);
        }}
        primaryBtn={{
          label: t('chat:uploadAlert.viewDetails'),
          onClick: () => {
            onViewDetails();
            toggleAlertOpen(false);
          },
        }}
        data-testid="upload-alert"
      />
    )
  );
};
